import BaseAPI from "@/apis/base/base-api";
import httpClient from "@/apis/base/axios-httpclient";

class AllocationReduceLocationAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "AllocationReduceLocation";

  /**
   * @override: Lấy dữ liệu danh sách
   * @author ntnghia - 24.03.2021
   */
  getList(payload) {
    // URL mặc định

    let url = this.getAPIUrl() + "/location-allocation-reduce";
    payload.columns =
      "LocationCode,LocationName,ParentName,OrganizationUnitName,NumberAssetUse, NumberAssetSum, NumberAssetLostCancelLiquidated,Description,Inactive,IsParent,LocationID";

    // Build tham số
    let request = {
      url: url,
      data: payload,
    };

    // Call api
    return httpClient.postAsync(request);
  }
}

export default new AllocationReduceLocationAPI();
